// removed by extract-text-webpack-plugin
module.exports = {"feature":"src-components-Feature----feature-module---feature---7uPQP","icon":"src-components-Feature----feature-module---icon---1Bljw","wiggle":"src-components-Feature----feature-module---wiggle---3M1qP","balloon":"src-components-Feature----feature-module---balloon---3lIpa","title":"src-components-Feature----feature-module---title---3Ie78","content":"src-components-Feature----feature-module---content---3ObVm"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Feature/feature.module.sass
// module id = 356
// module chunks = 195351340454287